import { render, staticRenderFns } from "./RefundGuide.vue?vue&type=template&id=09411b72&scoped=true&"
import script from "./RefundGuide.vue?vue&type=script&lang=js&"
export * from "./RefundGuide.vue?vue&type=script&lang=js&"
import style0 from "./RefundGuide.vue?vue&type=style&index=0&id=09411b72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09411b72",
  null
  
)

export default component.exports